module.exports = __webpack_public_path__ + "static/media/appStore_V2.6d733e53.svg";